export const badGiftsURLs = {
    twitter: 'https://twitter.com/realbadgifts',
    openSea: 'https://opensea.io/collection/bad-gifts',
    discord: '#',
    badGiftsSite: '#',
}